import { get, post } from '@web3/base-utils';

export type HackConfig = {
  chainCodes: string[];
  entities: {
    name: string;
    logo: string;
    twitterUrls: [];
    telegramUrls: [];
  }[];
};

export type PostReportParams = {
  entityName: string;
  entityUserAddress: string;
  fundAmount: string;
  fundTokenName: string;
  relatedTxHash: string;
  reporterName: string;
  reporterAddress: string;
  reportContactInfo: string;
  reportFile: string;
  reportText: string;
  sign: string;
  msg: string;
};

export const getHackConfig = (data?: {}) => {
  return get<HackConfig>(`/spot/api/web3/content/hack/config`, data);
};

export const postReport = (data: PostReportParams) => {
  return post<boolean>('/spot/api/web3/content/hack/report', data);
};
